export const AUTOPLAY_DELAY = 5000
